import {UserRoles} from '@ozark/common';
import {useAuth} from '../firebase/hooks/useAuth';

export const isAgentOrErpUser = (authStore: ReturnType<typeof useAuth>) => {
  const {authUser} = authStore;
  return Boolean(
    authUser.claims && authUser.claims?.portal && authUser?.claims?.role !== UserRoles.merchant
  );
};
